import React from 'react';
import { useTranslation } from 'react-i18next';
import { useProbeContext } from '@/probe/ProbeContext';

const ProbeSelector: React.FC = () => {
  const { t } = useTranslation('webflash');
  const { isConnecting, targetInfo, error, connect, disconnect } = useProbeContext();

  const webUSBSupported = typeof navigator !== 'undefined' && 'usb' in navigator;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('connect.title')}
      </h3>

      {!webUSBSupported ? (
        <p className="text-sm text-red-500">{t('connect.noWebUSB')}</p>
      ) : (
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <div
              className={`w-3 h-3 rounded-full ${
                targetInfo ? 'bg-green-500' : 'bg-gray-300 dark:bg-gray-600'
              }`}
            />
            <span className="text-sm text-gray-600 dark:text-gray-400">
              {targetInfo ? t('connect.connected') : t('connect.disconnected')}
            </span>
          </div>

          {error && <p className="text-sm text-red-500">{error}</p>}

          <button
            onClick={targetInfo ? disconnect : connect}
            disabled={isConnecting}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              targetInfo
                ? 'bg-red-100 text-red-700 hover:bg-red-200 dark:bg-red-900 dark:text-red-300'
                : 'bg-blue-600 text-white hover:bg-blue-700'
            } disabled:opacity-50`}
          >
            {isConnecting
              ? t('connect.connecting')
              : targetInfo
                ? t('connect.disconnect')
                : t('connect.selectProbe')}
          </button>
        </div>
      )}
    </div>
  );
};

export default ProbeSelector;
